import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export var createAggregatedClient = function createAggregatedClient(commands, Client) {
  var _loop = function _loop() {
    var command = _Object$keys[_i];
    var CommandCtor = commands[command];
    var methodImpl = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, optionsOrCb, cb) {
        var command;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                command = new CommandCtor(args);
                if (!(typeof optionsOrCb === "function")) {
                  _context.next = 5;
                  break;
                }
                this.send(command, optionsOrCb);
                _context.next = 12;
                break;
              case 5:
                if (!(typeof cb === "function")) {
                  _context.next = 11;
                  break;
                }
                if (!(typeof optionsOrCb !== "object")) {
                  _context.next = 8;
                  break;
                }
                throw new Error("Expected http options but got ".concat(typeof optionsOrCb));
              case 8:
                this.send(command, optionsOrCb || {}, cb);
                _context.next = 12;
                break;
              case 11:
                return _context.abrupt("return", this.send(command, optionsOrCb));
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      return function methodImpl(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();
    var methodName = (command[0].toLowerCase() + command.slice(1)).replace(/Command$/, "");
    Client.prototype[methodName] = methodImpl;
  };
  for (var _i = 0, _Object$keys = Object.keys(commands); _i < _Object$keys.length; _i++) {
    _loop();
  }
};